import ProjectScopeDocViewComponent from './scope-doc-view.component'

const ProjectScopeDocViewModule = angular.module('cdbl.scope-doc-view', [

])
  .component('cdblProjectScopeDocView', ProjectScopeDocViewComponent)
  .name

export default ProjectScopeDocViewModule
